import React, { useState, useEffect } from 'react';

const imagesByProduct = {
  '65W_EM': [
    { id: 1, title: 'Starlight Classic', src: '/images/6.jpeg' },
    { id: 2, title: 'Starlight Classic', src: '/images/2.jpeg' },
    { id: 3, title: 'Starlight Classic', src: '/images/4.jpeg' },
    { id: 4, title: 'Starlight Classic', src: '/images/5.jpeg' },
  ],
  '80W_FM': [
    { id: 'air-1', title: 'Starlight Air', src: '/images/product/hero-pinch.jpg' },
    { id: 'air-2', title: 'Starlight Air', src: '/images/product/air-studio-3.png' },
    { id: 'air-3', title: 'Starlight Air', src: '/images/product/_5II2789-Edit.jpg' },
  ],
};

const ImageCarousel = ({ product = '65W_EM' }) => {
  const images = imagesByProduct[product] || imagesByProduct['65W_EM'];
  const [activeImage, setActiveImage] = useState(0);

  // Reset to first image when product changes
  useEffect(() => {
    setActiveImage(0);
  }, [product]);

  const handleThumbnailClick = React.useCallback((index, event) => {
    if (index !== activeImage) {
      setActiveImage(index);
    }
  }, [activeImage]);

  const goToPrevious = React.useCallback(() => {
    setActiveImage((prev) => (prev > 0 ? prev - 1 : images.length - 1));
  }, [images.length]);

  const goToNext = React.useCallback(() => {
    setActiveImage((prev) => (prev < images.length - 1 ? prev + 1 : 0));
  }, [images.length]);

  return (
    <div className="image-carousel">
      <div className="carousel-main-image">
        <div className="carousel-image-container">
          <img 
            src={images[activeImage].src}
            alt={images[activeImage].title}
            className={`carousel-image image-${images[activeImage].id}`}
            loading={activeImage === 0 ? "eager" : "lazy"}
            decoding="sync"
          />
        </div>
      </div>
      
      <div className="carousel-thumbnails">
        {images.map((image, index) => (
          <button
            key={image.id}
            className={`carousel-thumbnail ${index === activeImage ? 'active' : ''}`}
            onClick={(e) => handleThumbnailClick(index, e)}
            aria-label={`View ${image.title}`}
            type="button"
          >
            <div className="carousel-image-container">
              <img 
                src={image.src}
                alt={image.title}
                className={`carousel-image image-${image.id} loaded`}
                loading="lazy"
                decoding="async"
                fetchpriority="low"
              />
            </div>
          </button>
        ))}
      </div>
      
      {/* Mobile arrow navigation */}
      <div className="carousel-navigation">
        <button
          className="carousel-arrow carousel-arrow-prev"
          onClick={goToPrevious}
          aria-label="Previous image"
          type="button"
        >
          ‹
        </button>
        <div className="carousel-counter">
          {activeImage + 1} / {images.length}
        </div>
        <button
          className="carousel-arrow carousel-arrow-next"
          onClick={goToNext}
          aria-label="Next image"
          type="button"
        >
          ›
        </button>
      </div>
    </div>
  );
};

export default ImageCarousel;
